import React from 'react';
import { PaddedRow, CenteredCol } from '../../StyledPrimitives/StyledPrimitives';

const TitledCell = (props) => (
    <PaddedRow>
        <CenteredCol>
            <h1>{props.title}</h1>
            {props.children}
        </CenteredCol>
    </PaddedRow>
);

export default TitledCell;


// WEBPACK FOOTER //
// ./src/components/UI/TitledCell/TitledCell.js